import ReactDOM from 'react-dom/client';
import App from './App';
import { initEmbedTheme } from './theme';
import './styles/tokens.css';
import './index.css';

initEmbedTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
);

